// istanbul ignore file
// TODO: Remove as part of DMD-4863
import { createTheme } from '@mui/material/styles';
import get from 'lodash/get';

import {
  fontFaceStyle,
  transformBrandStyle
} from '@getbento/website-components';
import { BrandFontTypes } from 'reservations/brand/constants/enums';
import { getComponents } from 'reservations/brand/helpers/components';
import { getPalette } from 'reservations/brand/helpers/palette';
import {
  getTypography,
  loadBrandFont
} from 'reservations/brand/helpers/typography';
import { BrandFont, BrandStyles } from 'reservations/brand/types/brand';

export const createBrandMuiTheme = (
  styles: BrandStyles,
  fonts: BrandFont[] = []
) => {
  // Style
  const brandStyles = get(styles, 'styles', []);
  const spacing = get(styles, 'base.padding', 8);
  const borderWidth = get(styles, 'base.borderWidth', 2);
  const borderRadius = get(styles, 'base.borderRadius', 4);

  const initialTheme = createTheme();

  const transformedBrandStyles = transformBrandStyle(
    initialTheme.breakpoints,
    brandStyles,
    {
      spacing,
      borderWidth,
      borderRadius
    }
  );

  // Typography
  const typography = getTypography(transformedBrandStyles);

  // Palette
  const palette = getPalette(transformedBrandStyles);

  // Font
  // Google fonts are loaded in useBrandData hook
  const customFonts = fonts.filter(
    font => font.fontType === BrandFontTypes.CUSTOM
  );
  const customFontFaces = customFonts.map(customFont =>
    fontFaceStyle(customFont.slug, customFont.sources)
  );
  const defaultFontFaces = loadBrandFont();

  // Component style override
  const brandFontFaces = [...defaultFontFaces, ...customFontFaces];

  // Using base theme for breakpoints
  const baseTheme = createTheme();
  const components = getComponents(
    brandFontFaces,
    palette,
    typography,
    baseTheme
  );

  // MUI theme
  return createTheme({
    typography,
    palette,
    components
  });
};

export type MuiTheme = ReturnType<typeof createBrandMuiTheme>;
